import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule, TuiLabelModule } from "@taiga-ui/core";
import { TuiInputSliderModule } from "@taiga-ui/kit";
import { KwikUIInputSliderComponent } from "./input-slider.component";

@NgModule({
  declarations: [KwikUIInputSliderComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiLabelModule
  ],
  exports: [KwikUIInputSliderComponent]
})
export class KwikUIInputSliderModule {}
